<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Palavras</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <word-page/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import WordPage from '../components/WordPage.vue';

export default {
  name: 'word-create',
  components: {
    WordPage,
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>

